(function () {
    'use strict';

    angular
        .module('salesflare.components.detectEllipsis', [])
        .directive('sfDetectEllipsis', sfDetectEllipsis);

    function sfDetectEllipsis($timeout) {

        return {
            restrict: 'A',
            scope: false,
            link
        };

        function link(scope, element, attrs) {

            const el = element[0];
            let pending;

            function check() {

                pending = null;

                const field = scope.$eval(attrs.sfDetectEllipsis);

                // Only measure while collapsed, otherwise the ellipsis is not
                // active and the element would never report an overflow. When
                // the field is expanded we keep the arrow so it can be collapsed.
                if (!field || field.extended) {
                    return;
                }

                field.extendable = el.scrollWidth > el.clientWidth;
            }

            function scheduleCheck() {

                if (pending) {
                    return;
                }

                // Defer so the value is interpolated and laid out before measuring.
                pending = $timeout(check);
            }

            scope.$on('$destroy', function () {

                $timeout.cancel(pending);
            });

            // Re-measure when the value changes and when the bound field is
            // replaced. After saving edits the controller reloads the fields,
            // which resets extendable on fresh objects even when the text
            // itself did not change.
            scope.$watch(attrs.sfDetectEllipsis, scheduleCheck);
            scope.$watch(function () {

                return el.textContent;
            }, scheduleCheck);
        }
    }
})();
